import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import { featureKey } from './teams.reducer';

export const TeamsState = (state: AppState) => state[featureKey];

export const selectTeams = createSelector(
  TeamsState,
  (state) => state.teams,
);

export const selectTeamsMap = createSelector(
  TeamsState,
  (state) => state.teamsMap,
);

export const selectTeamsMatchesMap = createSelector(
  TeamsState,
  (state) => state.teamsMatchesMap,
);


export const selectSelectedTeam = createSelector(
  TeamsState,
  (state) => {

    return state.teams?.find((team) => {
      return team.slug === state.slug;
    });
  },
);
